import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-cyber.mp4';
import DatacenterImage from '../../../assets/images/data-center.jpeg';
import CloudImage from '../../../assets/images/openspaceazure.jpg';
import './IntroSectionCyberData.css';

const IntroSectionCyberAudit2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-cyber-audit-2">
      {/* Video and Images Section */}
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('auditCyber.section1.title', 'Des tests d\'intrusion')}</h2>
            <h3>{t('auditCyber.section1.description', 'Nous proposons des audits de cybersécurité, complets, menés par des experts, pour évaluer votre niveau de sécurité, identifier vos vulnérabilités et proposer des solutions adaptées.')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('auditCyber.video.notSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('auditCyber.section2.title', 'Évaluez vos systèmes')}</h2>
            <h3>{t('auditCyber.section2.description', 'Un audit de cybersécurité identifie les vulnérabilités de vos infrastructures, applications et processus avant qu\'elles ne soient exploitées. C\'est un investissement essentiel pour protéger votre entreprise et assurer sa pérennité.')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={DatacenterImage}
              alt={t('auditCyber.section2.imageAlt', 'Security')}
            />
          </div>
        </div>

        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('auditCyber.section3.title', 'Votre partenaire spécialisé.')}</h2>
              <h3>{t('auditCyber.section3.description1', 'Nous maîtrisons les environnements cloud les plus complexes et assurons une gestion fluide et efficace de votre architecture cloud, quelle que soit sa taille.')}</h3>
              <h3>{t('auditCyber.section3.description2', 'Notre objectif est de vous offrir une infrastructure stable, sécurisée et évolutive, tout en libérant vos ressources internes pour mieux innover et développer votre activité.')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CloudImage}
                loading="lazy"
                className="intro-media"
                alt={t('auditCyber.section3.imageAlt', 'Azure OpenAI')}
              />
            </div>
          </div>
        </div>

        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionCyberAudit2;
